import { useQuery } from "@tanstack/react-query";

import { getDashboardSummary } from "../../api/auth/auth.api.js";


export const useDashboardSummary = () => {
  return useQuery({
    queryKey: ["dashboardSummary"],
    queryFn: getDashboardSummary,
  });
};